import { render, staticRenderFns } from "./sysuser_batch_set_star.vue?vue&type=template&id=c4872f9c&scoped=true"
import script from "./sysuser_batch_set_star.vue?vue&type=script&lang=js"
export * from "./sysuser_batch_set_star.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4872f9c",
  null
  
)

export default component.exports